import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { BusinessSettingForm } from '@/components/forms/BusinessSettingForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function BusinessSettingCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/service-catalog/business-settings')
  }

  const handleCancel = () => {
    navigate('/service-catalog/business-settings')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex={1}>
          <Card h="full" display="flex" flexDirection="column">
            <CardHeader flexShrink={0}>
              <Heading size="md">Create Business Setting</Heading>
              <Text fontSize="sm" color={colors.text} mt={1}>
                Add a new business setting
              </Text>
            </CardHeader>
            <CardBody overflowY="auto" flex={1} minH={0}>
              <BusinessSettingForm onSuccess={handleSuccess} onCancel={handleCancel} />
            </CardBody>
          </Card>
        </Box>
      </Box>
    </AdminLayout>
  )
}
